module.exports = __webpack_public_path__ + "img/to-horisontal.e663ffb3.gif";